var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialmediaico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    fill: "#d44a00",
    stroke: "#d44a00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_100_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Next"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Last"
  }), /*#__PURE__*/React.createElement("g", {
    id: "OK"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fail"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_0_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_100_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forbidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compass"
  }), /*#__PURE__*/React.createElement("g", {
    id: "World"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Microphone"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Options"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chronometer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Position"
  }), /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Options_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Turn_x5F_On_x5F_Off"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Height"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Width"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Screen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compress_x5F_Screen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bluetooth"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_iOS"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_Android"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M50.016,73.188c-6.403,0-12.2-2.595-16.396-6.791C29.423,62.2,26.828,56.403,26.828,50c0-6.402,2.594-12.197,6.788-16.393 c4.196-4.198,9.995-6.795,16.399-6.795c12.806,0,23.188,10.381,23.188,23.188S62.822,73.188,50.016,73.188z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 40.188,
    cy: 50,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M49.188,40c0-2.761,2.239-5,5-5c2.761,0,5,2.239,5,5s-2.239,5-5,5c-1.553,0-2.941-0.708-3.858-1.82 C49.616,42.316,49.188,41.208,49.188,40z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 54.188,
    cy: 60,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.169,
    y1: 46.984,
    x2: 50.016,
    y2: 42.753
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#d44a00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 50.016,
    y1: 56.984,
    x2: 45.047,
    y2: 53.631
  })), /*#__PURE__*/React.createElement("g", {
    id: "Love__x2F__Favorite"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hamburguer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flying"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Take_x5F_Off"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Land"
  }), /*#__PURE__*/React.createElement("g", {
    id: "City"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nature"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pointer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Prize"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Extract"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pause"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stop"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forward"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reverse"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Next_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Last_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Empty_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Error_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "OK_x5F_Basket"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaico);
export default __webpack_public_path__ + "static/media/socialmediaico.301085a2ff4a98e3f9ab715ec8de6896.svg";
export { ForwardRef as ReactComponent };